import styled from 'styled-components';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const FormField = styled.div`
    display: inline-block;
`;
